import type { HeadingTypes } from '@etg/wings';
import { Heading } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { TripType } from '@eti/schema-types';
import { getBoundTitle, getBoundType } from '../../../../../../widgets/trip-details/utils/format';

interface ItineraryBoundTitleProps {
  boundId: string;
  boundIndex: number;
  dataTestIdPrefix: string;
  headingAs?: `h${HeadingTypes['level']}`;
  journeyType: TripType;
}
const BoundTitle = ({
  boundId,
  boundIndex,
  dataTestIdPrefix,
  headingAs = 'h3',
  journeyType,
}: ItineraryBoundTitleProps) => {
  const { t } = useTranslation();
  const boundTitle = t(
    getBoundTitle(getBoundType(boundIndex), journeyType === TripType.MultiStop),
    parseInt(boundId, 10) + 1,
  );
  return (
    <Heading as={headingAs} data-testid={`${dataTestIdPrefix}-bound-${boundId}-title`} level={3}>
      {boundTitle}
    </Heading>
  );
};

export default BoundTitle;
